/* eslint-disable react/display-name */
import React from 'react';
import ReactSelect from 'react-select';
import { useTranslation } from 'react-i18next';
import {
  getCustomTheme,
  customStyles,
  IndicatorSeparator,
  DropdownIndicator,
  ControlComponent,
  LoadingIndicator,
  Option,
  MenuListVirtualized,
  SingleValue,
} from './customization';
import './styles.css';

type Props = Partial<React.ComponentProps<typeof ReactSelect>>;

const SelectDropdownVirtual = React.forwardRef<Props['ref'], Props>(
  (props, ref) => {
    // HOOKS
    const { t } = useTranslation();

    // RENDER
    return (
      <ReactSelect
        ref={ref}
        // to allow virtual list working
        captureMenuScroll={false}
        components={{
          Control: ControlComponent,
          IndicatorSeparator,
          DropdownIndicator,
          LoadingIndicator,
          Option,
          SingleValue,
          MenuList: MenuListVirtualized,
        }}
        theme={getCustomTheme}
        styles={customStyles}
        menuPlacement="auto"
        placeholder={t('filters:Select')}
        maxMenuHeight={200}
        {...props}
      />
    );
  }
);

export default SelectDropdownVirtual;
